import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import AdminPageLayout from "../../../components/FullPageLayout/AdminPageLayout";
import PolicyLogoSetting from "./PolicyLogoSetting";
import PolicyAcknowledgmentSetting from "./PolicyAcknowledgmentSetting";
import { useAdminSettings } from "../../../hooks/adminSettings";
import { useSnackbarNotifications } from "../../../hooks/snackbar";
import useScopedTranslation from "../../../hooks/useScopedTranslation";
import { useDispatch } from "react-redux";
import {
  updatePolicyLogoImage,
  clearPolicyLogoImage
} from "../../../redux/actions/learningCenterSettingsActions";
import Logo from "../../../components/Logo";

const PolicySettings = () => {
  const dispatch = useDispatch();
  const t = useScopedTranslation("policySettings");
  const [settingsData, setSettingsData] = useState(null);
  const {
    isLoading,
    isSaving,
    getPolicySettings,
    updatePolicySettings,
    policyLogoImage
  } = useAdminSettings();

  const {
    displaySuccessMessage,
    displayErrorMessage
  } = useSnackbarNotifications();

  useEffect(() => {
    const fetchPolicySettings = async () => {
      const data = await getPolicySettings();
      setSettingsData(data);
    };
    fetchPolicySettings();
  }, []);

  const handleUpdate = async values => {
    const response = await updatePolicySettings(values);
    if (response.errors || response.error) {
      displayErrorMessage(t("errorMsg"));
    } else {
      setSettingsData(response);
      displaySuccessMessage(t("successMsg"));
    }
  };

  const handleLogoUpload = (imageFile, rawFile) => {
    dispatch(updatePolicyLogoImage(imageFile, rawFile));
  };

  const clearLogo = () => {
    dispatch(clearPolicyLogoImage());
  };

  const logo = policyLogoImage ? (
    <Logo id={"policyLogoImage"} logo={policyLogoImage} />
  ) : (
    ""
  );
  return (
    <AdminPageLayout title={t("title")}>
      <Box display="flex" flexDirection="column" my={4}>
        <PolicyLogoSetting
          onLogoUpload={handleLogoUpload}
          logo={logo}
          clearLogo={clearLogo}
        />
        {settingsData && (
          <PolicyAcknowledgmentSetting
            disabled={isLoading || isSaving}
            acknowledgementText={settingsData.policyAcknowledgementText}
            onUpdate={handleUpdate}
          />
        )}
      </Box>
    </AdminPageLayout>
  );
};

export default PolicySettings;
